import { gql } from '@apollo/client';

export const PREVIEW_RENDERER_VERSION_FILE_FRAGMENT = gql`
  fragment PreviewRenderer_VersionFileFragment on VersionFile {
    _id
    file {
      _id
      name
      url
      type
      imageProxy(input: {})
    }
    dateCreated
    originalPost {
      _id
    }
    originalComment {
      _id
    }
    author {
      _id
      displayName
      proxyProfilePictureUrl(
        input: { w: 40, h: 40, fit: "facearea", facepad: 10.0 }
      )
    }
  }
`;
